/**
 * Katie's health, and the window of safety after being hit.
 *
 * Invulnerability frames are not a nicety: without them, standing inside an
 * enemy applies contact damage every frame and a mistake becomes death before
 * the player can react. The window is what turns a hit into a warning.
 */

export const INVULNERABLE_SECONDS = 0.9;

export class Health {
  private invulnerable = 0;

  constructor(
    readonly max: number,
    private value = max,
  ) {}

  get current(): number {
    return this.value;
  }

  get isDown(): boolean {
    return this.value <= 0;
  }

  get isInvulnerable(): boolean {
    return this.invulnerable > 0;
  }

  /** For the blink that tells the player why they are not taking damage. */
  get invulnerableRemaining(): number {
    return this.invulnerable;
  }

  update(dt: number): void {
    this.invulnerable = Math.max(0, this.invulnerable - dt);
  }

  /** Returns true if the hit landed. Ignored entirely during i-frames. */
  damage(amount: number): boolean {
    if (this.invulnerable > 0 || amount <= 0 || this.isDown) return false;
    this.value = Math.max(0, this.value - amount);
    this.invulnerable = INVULNERABLE_SECONDS;
    return true;
  }

  heal(amount: number): void {
    this.value = Math.min(this.max, this.value + Math.max(0, amount));
  }

  restore(): void {
    this.value = this.max;
    this.invulnerable = 0;
  }
}
